import React from 'react';
import { EnterpriseTokens } from '@/theme/enterprise-tokens';
import styles from './WorkspaceLayout.module.css';

export interface WorkspaceLayoutProps {
  header?: React.ReactNode;
  workflow?: React.ReactNode;
  children: React.ReactNode;
  rightRail?: React.ReactNode;
  fullBleed?: boolean;
  /** Zero body padding (immersive workbench). Often paired with fullBleed. */
  denseBody?: boolean;
}

/**
 * Object workspace chrome: header + optional workflow + body [+ optional rail].
 */
export const WorkspaceLayout: React.FC<WorkspaceLayoutProps> = ({
  header,
  workflow,
  children,
  rightRail,
  fullBleed,
  denseBody,
}) => {
  const t = EnterpriseTokens.workspace;
  const mainPadding = denseBody
    ? 0
    : `clamp(${EnterpriseTokens.workspace.bodyPaddingMin}px, 3vw, ${t.bodyPadding}px)`;
  return (
    <div
      style={{
        margin: 0,
        borderRadius: fullBleed ? 0 : 8,
        overflow: fullBleed ? 'visible' : 'hidden',
        border: fullBleed ? undefined : t.borderSubtle,
        background: '#fff',
        display: 'flex',
        flexDirection: 'column',
        minHeight: fullBleed ? 'calc(100vh - 64px)' : undefined,
        maxWidth: '100%',
      }}
    >
      <div style={{ flexShrink: 0, position: 'relative', zIndex: 3 }}>{header}</div>
      {workflow}
      <div className={styles.body} style={{ flex: 1, minHeight: 0 }}>
        <div className={styles.main} style={{ padding: mainPadding, minWidth: 0, maxWidth: '100%' }}>
          {children}
        </div>
        {rightRail && (
          <aside
            className={styles.rail}
            style={{
              width: t.railWidth,
              padding: `clamp(${EnterpriseTokens.workspace.bodyPaddingMin}px, 3vw, ${t.bodyPadding}px)`,
            }}
          >
            {rightRail}
          </aside>
        )}
      </div>
    </div>
  );
};
